import { ErrorMessages } from './error-messages';
import { ACCEPT_TERMS, SIGN_UP, SIGNUP_FIELDS } from './signUp.constants';
import { USER } from './user.constants';

export const CONSTANTS = {
  ErrorMessages,
  USER,
  SIGNUP_FIELDS,
  SIGN_UP,
  ACCEPT_TERMS,
};
